"use client";

import type { QuickFilter } from "../types";
import type { TopSellersFilterState } from "@/features/topsellers/types";

interface QuickFilterButtonsProps {
  filters: QuickFilter[];
  appliedFilters: TopSellersFilterState;
  onToggle: (next: TopSellersFilterState) => void;
}

export function QuickFilterButtons({
  filters,
  appliedFilters,
  onToggle,
}: QuickFilterButtonsProps) {
  if (filters.length === 0) return null;

  return (
    <>
      {filters.map((qf) => {
        const active = qf.isActive(appliedFilters);
        return (
          <button
            key={qf.id}
            type="button"
            onClick={() => onToggle(qf.onToggle(appliedFilters))}
            className={`inline-flex items-center gap-2 h-10 px-3 rounded-lg border transition-colors text-sm font-medium ${
              active
                ? "border-[#66c0f4]/60 bg-[#1f2e3f] text-[#66c0f4]"
                : "border-[#2a475e]/50 bg-[#16202d]/50 text-[#c7d5e0] hover:bg-[#1f2e3f]/50 hover:border-[#3a556e]"
            }`}
          >
            {qf.label}
          </button>
        );
      })}
    </>
  );
}
